import { render, staticRenderFns } from "./Passo2.vue?vue&type=template&id=b0901f08&"
import script from "./Passo2.vue?vue&type=script&lang=js&"
export * from "./Passo2.vue?vue&type=script&lang=js&"
import style0 from "./Passo2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports